import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables:', {
    url: !!supabaseUrl,
    key: !!supabaseAnonKey
  });
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce',
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
  global: {
    headers: {
      'X-Client-Info': 'safeplay-ai-web'
    }
  },
  db: {
    schema: 'public'
  }
});

// Enable real-time for subscription-related tables
export const enableRealtimeForSubscriptions = () => {
  console.log('Enabling real-time subscriptions for purchase tables');
  
  // The real-time subscriptions are set up in the useRealtimeSubscription hook
  // This function can be used to globally configure real-time settings if needed
  
  return {
    tables: ['stripe_customers', 'stripe_subscriptions', 'stripe_payments'],
    events: ['INSERT', 'UPDATE', 'DELETE'],
    enabled: true
  };
};